import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { env } from '../../environments/environment';
import { InspectionItem, ListFilters, ListResults, Question, Section } from '../shared/interfaces';

@Injectable({
  providedIn: 'root',
})
export class SectionService {
  constructor(protected http: HttpClient) {}

  list(filters?: ListFilters) {
    return this.http.get<ListResults<Section>>(`${env.APIUrl}/section`, { params: filters as any });
  }

  get(id: number, versionName: string) {
    return this.http.get<Section>(`${env.APIUrl}/section/${id}`, { params: { versionName } }).toPromise();
  }

  archived(filters?: ListFilters) {
    return this.http
      .get<ListResults<Section>>(`${env.APIUrl}/section/archived`, { params: filters as any })
      .toPromise();
  }

  archive(id: number, versionName: string) {
    return this.http.put<Section>(`${env.APIUrl}/section/${id}/archive`, null, { params: { versionName } }).toPromise();
  }

  restore(id: number) {
    return this.http.put<Section>(`${env.APIUrl}/section/${id}/restore`, null).toPromise();
  }

  edit(id: number, section: Section, versionName: string) {
    return this.http.put<Section>(`${env.APIUrl}/section/${id}`, section, { params: { versionName } }).toPromise();
  }

  move(inspectionItem: InspectionItem, id: number, newPosition: number, versionName: string) {
    return this.http
      .post<boolean>(`${env.APIUrl}/section/${id}/move`, { newPosition, inspectionItem }, { params: { versionName } })
      .toPromise();
  }

  create(section: Section, versionName: string) {
    return this.http.post<Section>(`${env.APIUrl}/section`, section, { params: { versionName } }).toPromise();
  }

  questions(sectionId: number, versionName: string) {
    return this.http.get<Question[]>(`${env.APIUrl}/section/${sectionId}/questions`, { params: { versionName } });
  }

  questionsFromVersion(sectionId: number, version: number) {
    return this.http.get<Question[]>(`${env.APIUrl}/section/${sectionId}/version/${version}/questions`);
  }
}
